import { getLocaleForLang } from '../shared/frontend/utils/i18n';
import { i18n, I18n } from '@lingui/core';
import { LocalTimeZone } from './LocalTimeZone';
import { importWithRetry } from './import';
import { Maybe } from '../GraphQL/schema/types';
import { ServerDateNow } from './serverDate';

export const getSessionTimeString = async (
  startTime?: string | null,
  language?: Maybe<string>,
  isOnDemandSession?: boolean,
  serverDateNow?: ServerDateNow,
  localI18n?: I18n
): Promise<[string, Date | null]> => {
  if (!startTime) {
    return ['{ sessionTime }', null];
  }
  const [{ EDate }, { SessionCalculator }] = await Promise.all([
    await importWithRetry(() => import('../shared/frontend/utils/EDate')),
    await importWithRetry(() => import('../shared/frontend/utils/SessionCalculator')),
  ]);
  const { text, date } = await SessionCalculator.formatSessionTime({
    locale: getLocaleForLang(language ?? 'en'),
    date: new EDate(startTime, LocalTimeZone.name),
    i18n: localI18n ?? i18n,
    skipFromNow: true,
    isOnDemandSession,
    serverDateNow,
  });

  return [text, date];
};
